import { computed, type ComputedRef } from 'vue';
import { usePreferredReducedMotion } from '@vueuse/core';

export function usePrefersReducedMotion(): ComputedRef<boolean> {
  const preference = usePreferredReducedMotion();
  return computed(() => preference.value === 'reduce');
}
